// Which engines this build runs; written into every saved project and export
// (docs/ENGINE-GUIDE.md, "Versions"). GPL-3.0-or-later.
import { ENGINE as stereo } from "@dipfield/stereo";
import { ENGINE as rock } from "@dipfield/rock";
import { ENGINE as slope } from "@dipfield/slope";
import { ENGINE as wedge3d } from "@dipfield/wedge3d/version";
import { ENGINE as project } from "@dipfield/project";
import { version } from "../../package.json";

export const APP = { app: "DipField Suite", version } as const;
export const ENGINES: Record<string, string> = Object.fromEntries([stereo, rock, slope, wedge3d, project].map((e) => [e.name, e.version]));
